import React, { useContext } from 'react';
import Script from 'react-load-script';
import { Text } from 'grommet';
import { AuthorizedUserContext } from 'components/common/AuthorizedUser';

const jwt = require('jsonwebtoken');
const ssoSecretKey = process.env.REACT_APP_NOLT_SSO_SECRET_KEY;

const NOLT_SDK_URL = 'https://cdn.nolt.io/widgets.js';
const NOLT_BOARD_URL = 'https://07044696.nolt.io/';

// TODO: Make token only once
const makeToken = authorizedUser => {
  const payload = {
    // The ID that you use in your app for this user
    id: authorizedUser.uid,
    // The user's email address that
    // Nolt should use for notifications
    email: authorizedUser.email,
    // The display name for this user
    name: authorizedUser.displayName
    // Optional: The URL to the user's avatar picture
    /* TODO imageUrl: user.imageUrl */
  };

  try {
    const token = jwt.sign(payload, ssoSecretKey, { algorithm: 'HS256' });
    return token;
  } catch (error) {
    console.log(error.message);
  }
};

const setIdentity = authorizedUser => {
  if (authorizedUser != null) {
    // TODO: getToken || makeToken
    const token = makeToken(authorizedUser);
    try {
      const { nolt } = window;
      nolt('identify', { jwt: token });
    } catch (error) {
      console.log(error.message);
    }
  }
};

const NoltButton = () => {
  const authorizedUser = useContext(AuthorizedUserContext);
  
  const styles = {
    background: 'transparent',
    borderColor: '#6FFFB0',
    borderRadius: '24px',
    borderWidth: '2px',
    cursor: 'pointer',
    marginBottom: '6px',
    paddingBottom: '3px',
    paddingTop: '4px'
  };

  return (
    <>
      <button style={styles} className="nolt-button">
        {
          <Text color="light-1" margin="large" size="medium" weight="bold">
            Make a suggestion
          </Text>
        }
      </button>
      <Script
        url={NOLT_SDK_URL}
        onCreate={() => {}}
        onError={() => {}}
        onLoad={() => {
          if(authorizedUser) { 
            setIdentity(authorizedUser)
          }
          const { nolt } = window;
          nolt('init', { selector: '.nolt-button', url: NOLT_BOARD_URL });
        }}
      />
    </>
    )
}

export default NoltButton;
